import * as types from './actionTypes';  
import configListApi from '../api/configListApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doFetchConfig() {

  return {
    type: types.DO_FETCH_CONFIGS, 
    
  };
}

export function doFetchConfigRes(data) {  
  return {
    type: types.DO_FETCH_CONFIGS_RES, 
    data
  };
}

export function fetchConfigList() {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      configListApi.doFetchConfig().then(data => {
        dispatch(doFetchConfigRes(data));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}